import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <div className="footerSection">
            <div className="footer">
                <Link to="/dashboard">© {new Date().getFullYear()} <strong style={{ color: '#4e9191' }}>Sat Kartar CRM</strong>. All Rights Reserved.</Link>
            </div>
        </div>
    )
}

export default Footer
